import { combineReducers, Reducer } from 'redux'

import { bondsTradingPane } from './bondsTradingPane'
import { appState } from './appState'
import { history } from './history'
import { appConfig } from './appConfig'
import { userAccount } from './tradingAccounts'
import { allowedLeverages } from './allowedLeverages'
import { tradingPane } from './tradingPane'
import { RootState } from '../types'
import { i18nReducer } from 'react-redux-i18n'
import { modal } from './dialogReducer'
import { bondsReducers } from './bondsReducers'
import { favourites } from './favourites'
import { positionsInputs } from './positionsInputs'
import { signals } from './signals'
import { candles } from './candles'
import {simpleSignals} from "./simpleSignals";
import {telegramSignals} from "./telegramSignals";

export default combineReducers({
  appConfig,
  userAccount,
  appState,
  history,
  tradingAccounts: userAccount,
  i18n: i18nReducer,
  allowedLeverages,
  tradingPane,
  modal,
  bondListState: bondsReducers,
  favourites,
  bondsTradingPane,
  positionsInputs,
  signals,
  simpleSignals,
  telegramSignals,
  candles,
}) as Reducer<RootState>
